import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DiscussionStateService } from './discussion-state.service';

@Component({
  selector: 'aura-discussions-button',
  standalone: true,
  imports: [MatIcon, MatIconButton, RouterLink],
  template: `
    <button mat-icon-button routerLink="/messages" aria-label="Messages" class="relative">
      <mat-icon svgIcon="message-square"></mat-icon>
      @if (unreadCount() > 0) {
        <span
          class="absolute top-[-2px] right-[-2px] min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-red-9 text-[8px] font-bold text-white leading-none border border-white shadow-sm z-10"
        >
          {{ unreadCount() > 99 ? '99+' : unreadCount() }}
        </span>
      }
    </button>
  `,
})
export class AuraDiscussionsButtonComponent {
  private readonly discussionState = inject(DiscussionStateService);
  protected readonly unreadCount = this.discussionState.unreadCount;
}
